package com.essntl.features.proposal.ui.addeditproposal.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.essntl.core.quickbooks.data.QuickbooksInvoice
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.invoice.ui.allinvoice.components.InvoiceItem
import com.essntl.uikit.components.dialog.EsDialog
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.spinner.EsSpinnerSize
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun InvoicesDialog(
    isOpen: Boolean,
    getQuickbooksInvoices: State<List<QuickbooksInvoice>>,
    loadingDownloadQuickbookIds: Set<String>,
    downloadQuickbooksInvoiceState: State<Pair<String, QuickbooksInvoice>>,
    onClick: (String) -> Unit,
    enabled: Boolean,
    onDownloadInvoice: (QuickbooksInvoice) -> Unit,
    onDismissRequest: () -> Unit,
) {
    if (isOpen) {
        EsDialog(
            title = "Invoices",
            onDismissRequest = onDismissRequest,
        ) {
            LazyColumn(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(.5.spacing),
                modifier = Modifier
                    .padding(2.5.spacing)
                    .heightIn(max = 440.dp),
            ) {
                when {
                    getQuickbooksInvoices.isFailure ->
                        item {
                            Box(
                                contentAlignment = Alignment.CenterStart,
                                modifier = Modifier
                                    .fillMaxSize()
                                    .padding(start = .5.spacing),
                            ) {
                                Text(
                                    text = "Failed to load Invoices",
                                    textAlign = TextAlign.Start,
                                    style = MaterialTheme.esTypography.p1Regular16,
                                    color = MaterialTheme.esColorScheme.textPrimary,
                                    modifier = Modifier
                                        .align(Alignment.CenterStart),
                                )
                            }
                        }

                    !getQuickbooksInvoices.isLoading && getQuickbooksInvoices.data.orEmpty().isEmpty() ->
                        item {
                            Box(
                                contentAlignment = Alignment.CenterStart,
                                modifier =
                                    Modifier
                                        .fillMaxSize()
                                        .padding(start = 0.5.spacing),
                            ) {
                                Text(
                                    text = "No Invoices found!",
                                    textAlign = TextAlign.Start,
                                    style = MaterialTheme.esTypography.p1Regular16,
                                    color = MaterialTheme.esColorScheme.textPrimary,
                                    modifier =
                                        Modifier
                                            .align(Alignment.CenterStart),
                                )
                            }
                        }

                    else ->
                        itemsIndexed(getQuickbooksInvoices.data.orEmpty()) { index, qbInvoice ->
                            key(qbInvoice.Id) {
                                InvoiceItem(
                                    qbInvoice = qbInvoice,
                                    loadingDownloadQuickbookIds = loadingDownloadQuickbookIds,
                                    downloadQuickbooksInvoiceState = downloadQuickbooksInvoiceState,
                                    enabled = enabled,
                                    onDownloadInvoice = {
                                        onDownloadInvoice(qbInvoice)
                                    },
                                    onClick = {
                                        onDismissRequest()
                                        onClick(qbInvoice.Id)
                                    },
                                )

                                if (index != getQuickbooksInvoices.data.orEmpty().lastIndex) {
                                    Spacer(modifier = Modifier.height(.5.spacing))

                                    HorizontalDivider(
                                        color = MaterialTheme.esColorScheme.borderPrimary,
                                    )
                                }
                            }
                        }
                }

                if (getQuickbooksInvoices.isLoading)
                    item {
                        Box(
                            contentAlignment = Alignment.Center,
                            modifier = Modifier.fillMaxSize(),
                        ) {
                            EsSpinner(
                                color = MaterialTheme.esColorScheme.iconPrimary,
                                size = EsSpinnerSize.Large,
                                modifier = Modifier
                                    .align(Alignment.Center),
                            )
                        }
                    }
            }
        }
    }
}